export default {
  mail_status: {
    see_message: "View message",
    see_incident: "View incident",
    not_filled: "Not available",
    field_label: "Mailbox status",
    status: {
      valid: "Valid",
      valid_with_incident: "Incident reported",
      temporary_block: "Temporary block",
      definitive_block: "Permanent block",
    },
    category: {
      reputation: "Sender reputation",
      unknown_recipient: "Unknown recipient",
      other: "Other",
    },
    reputation: {
      platform_alert:
        "A reputation issue affecting email deliverability has been detected on your platform. The technical team has been alerted and is actively working to resolve it.",
    },
    code: {
      invalid_email_format: "Invalid email format",
      transport_error: "Transport error",
      send_error: "Send error",
    },
    send_dot: {
      pending: "The email is being prepared, it has not been sent yet.",
      sent: "The email was sent successfully",
      incident: "The email was sent but the recipient server blocked it",
      blocked: "The email was not sent because of a problem with the recipient address",
      error: "The email could not be sent because of a technical error during sending",
      unknown: "This email's sending status is not recognized",
    },
    modal: {
      title: "Blocked email",
      title_incident: "Incident reported on the address",
      title_valid: "Mailbox status",
      blocked_at: "Blocked on",
      cause: "Cause",
      no_cause: "No message returned by the server",
      unblock: "Unblock now",
      unblock_error: "The block could not be lifted, please try again.",
      unblock_success: "Block lifted — the address is considered valid again.",
      hint_blocked: "Correct the address if needed, then unblock it manually.",
      hint_incident: "An incident was detected but did not reach the blocking threshold — no action required.",
      hint_valid: "This address works normally, no action required.",
    },
  },
};
